import React, { lazy } from 'react';
import { Check as CheckIcon } from 'lucide-react';
const VisualizateSection = () => {
  return <section className="py-16 bg-amber-50" data-id="element-310">
      <div className="container mx-auto px-4" data-id="element-311">
        <div className="max-w-3xl mx-auto" data-id="element-312">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center text-custom-brown" data-id="element-313">
            Visualízate dentro de 7 días:
          </h2>
          {/* Imagen de mamá e hija */}
          <div className="mb-8" data-id="element-314">
            <div className="img-container aspect-ratio-16-9 shadow-md rounded-lg" data-id="element-315">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rWSiWCfnDB8e5VGnTTDuDn/Madre_e_hija.jpg" alt="Madre e hija cocinando juntas" className="img-content" width="800" height="450" loading="lazy" onError={e => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = 'https://via.placeholder.com/800x450/f5f5f5/a97142?text=Madre+e+Hija+Cocinando';
            }} data-id="element-316" />
            </div>
          </div>
          <div className="space-y-4 mb-8" data-id="element-317">
            <div className="bg-white rounded-full py-3 px-6 shadow-md flex items-center" data-id="element-318">
              <div className="bg-custom-brown rounded-full p-1 mr-3" data-id="element-319">
                <CheckIcon size={16} className="text-white" data-id="element-320" />
              </div>
              <p className="text-custom-brown text-lg" data-id="element-321">Tus cenas... rápidas.</p>
            </div>
            <div className="bg-white rounded-full py-3 px-6 shadow-md flex items-center" data-id="element-322">
              <div className="bg-custom-brown rounded-full p-1 mr-3" data-id="element-323">
                <CheckIcon size={16} className="text-white" data-id="element-324" />
              </div>
              <p className="text-custom-brown text-lg" data-id="element-325">Tus hijos... felices.</p>
            </div>
            <div className="bg-white rounded-full py-3 px-6 shadow-md flex items-center" data-id="element-326">
              <div className="bg-custom-brown rounded-full p-1 mr-3" data-id="element-327">
                <CheckIcon size={16} className="text-white" data-id="element-328" />
              </div>
              <p className="text-custom-brown text-lg" data-id="element-329">Tu rutina... ligera.</p>
            </div>
          </div>
          <p className="text-center text-custom-brown text-lg" data-id="element-330">
            Y tú... con tiempo extra para descansar, leer o simplemente
            disfrutar. Es hora de soltar la culpa. Es hora de recuperar tu paz
            en la cocina.
          </p>
        </div>
      </div>
    </section>;
};
export default VisualizateSection;